export const mapOperacionActiva = (respuesta) => {
  if (!respuesta?.result) return null;

  const { numero, fchmov, codmov, codope, codres } = respuesta;

  if (codres === 0) {
    return {
      tipo: "Mis Ordenes",
      titulo: numero,
      codigo: codmov,
      path: `/ordenes/${codmov}`,
      fecha: fchmov,
      accionPausa: {
        url: `/ordenes/pausar/${codope}`,
        method: "PUT",
      },
      result: respuesta.result,
    };
  }

  if (codres === 1) {
    return {
      tipo: "Mis Reubicaciones",
      titulo: numero,
      codigo: codmov,
      path: `/reubicaciones/${codmov}`,
      fecha: fchmov,
      accionPausa: {
        url: `/ordenes/pausar/${codope}`,
        method: "PUT",
      },
      result: respuesta.result,
    };
  }

  // Auditoría de Stock
  if (codres === 2) {
    return {
      tipo: "Mis Auditorias",
      titulo: numero,
      codigo: codmov,
      path: `/auditorias/${codope}`,
      fecha: fchmov,
      accionPausa: {
        url: `/auditoria/operacion/${codmov}/pausar`,
        method: "PUT",
      },
      result: respuesta.result,
    };
  }

  // Auditoría SMA
  if (codres === 3) {
    return {
      tipo: "Auditar SMA",
      titulo: numero,
      codigo: codmov,
      path: `/auditar-sma/${codmov}`,
      fecha: fchmov,
      accionPausa: {
        url: `/auditoria-sma/operacion/${codmov}/pausar`,
        method: "PUT",
      },
      result: respuesta.result,
    };
  }

  return null;
};
